/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ContractType } from './';
import {
    ContractTypeFromJSON,
    ContractTypeFromJSONTyped,
    ContractTypeToJSON,
} from './';
import type { UpdateFixedPriceContractRequest } from './';
import {
    UpdateFixedPriceContractRequestFromJSON,
    UpdateFixedPriceContractRequestFromJSONTyped,
    UpdateFixedPriceContractRequestToJSON,
} from './';
import type { UpdateTimeAndMaterialsContractRequest } from './';
import {
    UpdateTimeAndMaterialsContractRequestFromJSON,
    UpdateTimeAndMaterialsContractRequestFromJSONTyped,
    UpdateTimeAndMaterialsContractRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateContractRequest
 */
export interface UpdateContractRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateContractRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractRequest
     */
    freelancerTermsAndConditions?: string;
    /**
     * 20.0
     * @type {number}
     * @memberof UpdateContractRequest
     */
    vatPercent?: number;
    /**
     * 
     * @type {ContractType}
     * @memberof UpdateContractRequest
     */
    type: ContractType;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractRequest
     */
    adminComment?: string;
}

/**
 * Check if a given object implements the UpdateContractRequest interface.
 */
export function instanceOfUpdateContractRequest(value: object): value is UpdateContractRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function UpdateContractRequestFromJSON(json: any): UpdateContractRequest {
    return UpdateContractRequestFromJSONTyped(json, false);
}

export function UpdateContractRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContractRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'FIXED_PRICE') {
            return UpdateFixedPriceContractRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'TIME_AND_MATERIALS') {
            return UpdateTimeAndMaterialsContractRequestFromJSONTyped(json, true);
        }
    }
    return {
        
        'title': json['title'],
        'freelancerTermsAndConditions': json['freelancerTermsAndConditions'] == null ? undefined : json['freelancerTermsAndConditions'],
        'vatPercent': json['vatPercent'] == null ? undefined : json['vatPercent'],
        'type': ContractTypeFromJSON(json['type']),
        'adminComment': json['adminComment'] == null ? undefined : json['adminComment'],
    };
}

export function UpdateContractRequestToJSON(value?: UpdateContractRequest | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'FIXED_PRICE') {
            return UpdateFixedPriceContractRequestToJSON(value as UpdateFixedPriceContractRequest);
        }
        if (value.type === 'TIME_AND_MATERIALS') {
            return UpdateTimeAndMaterialsContractRequestToJSON(value as UpdateTimeAndMaterialsContractRequest);
        }
    }
    return {
        
        'title': value['title'],
        'freelancerTermsAndConditions': value['freelancerTermsAndConditions'],
        'vatPercent': value['vatPercent'],
        'type': ContractTypeToJSON(value['type']),
        'adminComment': value['adminComment'],
    };
}

